import { defineComponent as _defineComponent } from 'vue'
import InlineIcon from '@/components/layout/shared/InlineIcon.vue';
import useClickOutside from '@/composables/useClickOutside';

import store from '@/store';

import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { VolumeBreakpoint } from '@/@types/VolumeBreakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerVolumeControl',
  props: {
    volume: null
  },
  emits: ["volumeChange"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'volumeChange', volume: number): number;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  volume: number;
}





const volumeControl = ref<HTMLElement>();

const volume = ref<number>(props.volume);
const isVisible = ref(false);
const dragging = ref(false);
const previousVolume = ref<number>(0);

const isMobile = computed((): boolean => store.state.isMobile);

const thumbStyle = computed(() => {
  return {
    bottom: `${(volume.value / 100) * 100 - 5}%`,
  };
});

const processStyle = computed(() => {
  return {
    height: `${volume.value}%`,
  };
});

const volumeStage = computed((): VolumeBreakpoint => {
  if (volume.value < 1) {
    return VolumeBreakpoint.Muted;
  } else if (volume.value < 35) {
    return VolumeBreakpoint.Min;
  } else {
    return VolumeBreakpoint.Max;
  }
});

const toggleVolumeSlider = () => (isVisible.value = !isVisible.value);

const toggleMute = () => {
  if (previousVolume.value === 0 && volume.value === 0) {
    previousVolume.value = volume.value;
    volume.value = 50;
  } else if (volume.value === 0) {
    volume.value = previousVolume.value;
  } else {
    previousVolume.value = volume.value;
    volume.value = 0;
  }

  emit('volumeChange', volume.value);
};

const handleVolumeButtonClick = () => {
  if (isMobile.value) {
    toggleMute();
  } else {
    toggleVolumeSlider();
  }
};

const getNewVolumeValue = (clientY: number, railRect: DOMRect): number => {
  const newPosition = (clientY - railRect.top) / railRect.height;
  return Math.round(Math.min(100, Math.max(0, (1 - newPosition) * 100)));
};

const onSliderClick = (event: MouseEvent) => {
  const railRect = document.querySelector('.slider__rail').getBoundingClientRect();
  const newVolumeValue = getNewVolumeValue(event.clientY, railRect);
  emit('volumeChange', newVolumeValue < 5 ? 0 : newVolumeValue);
};

const updateVolumeFromTouchEvent = (event: TouchEvent) => {
  const railRect = document.querySelector('.slider__rail').getBoundingClientRect();
  const newVolumeValue = getNewVolumeValue(event.touches[0].clientY, railRect);
  emit('volumeChange', newVolumeValue);
};

const onMouseMove = (event: MouseEvent) => {
  if (dragging.value) {
    event.preventDefault();
    const railRect = document.querySelector('.slider__rail').getBoundingClientRect();
    const newVolumeValue = getNewVolumeValue(event.clientY, railRect);
    emit('volumeChange', newVolumeValue);
  }
};

const onMouseDown = (event: MouseEvent) => {
  event.preventDefault();
  dragging.value = true;
  document.body.style.userSelect = 'none';
  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);
};

const onMouseUp = () => reset();

const onTouchStart = (event: TouchEvent) => {
  dragging.value = true;
  updateVolumeFromTouchEvent(event);
};

const onTouchMove = (event: TouchEvent) => {
  if (dragging.value) updateVolumeFromTouchEvent(event);
};

const onTouchEnd = () => (dragging.value = false);

const reset = () => {
  dragging.value = false;
  document.body.style.userSelect = '';
  window.removeEventListener('mousemove', onMouseMove);
  window.removeEventListener('mouseup', onMouseUp);
};

useClickOutside(volumeControl, () => (isVisible.value = false));

watch(
  () => isMobile.value,
  () => {
    isVisible.value = isMobile.value ? false : isVisible.value;
  }
);

watch(
  () => props.volume,
  () => {
    volume.value = props.volume;
  }
);

onBeforeUnmount(() => {
  reset();
});

return { __sfc: true,props, emit, volumeControl, volume, isVisible, dragging, previousVolume, isMobile, thumbStyle, processStyle, volumeStage, toggleVolumeSlider, toggleMute, handleVolumeButtonClick, getNewVolumeValue, onSliderClick, updateVolumeFromTouchEvent, onMouseMove, onMouseDown, onMouseUp, onTouchStart, onTouchMove, onTouchEnd, reset, InlineIcon }
}

})